import isCustomRecurrenceType from './isCustomRecurrenceType';
import RecurrenceConstants from './RecurrenceTypes';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import {
    isDailyRecurrence,
    isMonthlyRecurrence,
    isWeeklyRecurrence,
    isYearlyRecurrence,
} from './checkRecurrenceTypes';

export default function getSelectedRecurrenceKey(
    recurrence: RecurrenceType,
    includeCustom: boolean
): string {
    if (includeCustom && isCustomRecurrenceType(recurrence)) {
        return RecurrenceConstants.Custom;
    } else if (isDailyRecurrence(recurrence)) {
        return RecurrenceConstants.Daily;
    } else if (isWeeklyRecurrence(recurrence)) {
        return RecurrenceConstants.Weekly;
    } else if (isMonthlyRecurrence(recurrence)) {
        return RecurrenceConstants.Monthly;
    } else if (isYearlyRecurrence(recurrence)) {
        return RecurrenceConstants.Yearly;
    }

    return RecurrenceConstants.None;
}
